import styled from 'styled-components';

export const FormAddPermissionWrapper = styled.div`
  margin-bottom: 24px;
`;
